import { render, staticRenderFns } from "./AccountBadge.vue?vue&type=template&id=dd715180&scoped=true"
import script from "./AccountBadge.vue?vue&type=script&lang=js"
export * from "./AccountBadge.vue?vue&type=script&lang=js"
import style0 from "./AccountBadge.vue?vue&type=style&index=0&id=dd715180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd715180",
  null
  
)

export default component.exports